import logo from "../../assets/images/logo_parent.png";

const AuthCommonLeftPart = () => {
  return (
    <div className="col-md-5 left-side d-none d-md-block">
      <div className="d-flex flex-column gradient-custom-2 h-100 justify-content-between">
        <div
          className="text-white text-start px-2 py-4 p-md-5"
          style={{ margin: "2.5rem 2.5rem" }}
        >
          <h4 className="mb-4 fw-600">
            Digital Analytics for Physical <br />
            Products
          </h4>
          <p className="small mb-0 secondary_text">
            UseSights is a revolutionary solution that passively captures
            real-world product usage with unmatched precision. By combining
            patented smart sensors, real-time data capture, and advanced AI,
            UseSights provides authentic, moment-by-moment insights into if,
            when, how often, how much, how long, and why products are
            used—without relying on recall or self-reporting. This unique
            behavioral dataset empowers brands to uncover usage patterns,
            benchmark consumption, and identify new opportunities for innovation
            and growth.
          </p>
        </div>
        <div className="text-white">
          <p className="fw-600 text-start" style={{ marginLeft: "5.5rem" }}>
            Powered by <img src={logo} style={{ height: "30px" }} />
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthCommonLeftPart;
